import Banner from '../components/banner'
import Clientes from '../components/clientes'
import Contato from '../components/contato'
import Depoimentos from '../components/depoimentos'
import Marcas from '../components/marcas'
import Numeros from '../components/numeros'
import Rodape from '../components/rodape'
import Servicos from '../components/servicos'
import Verticais from '../components/verticais'
import Video from '../components/video'

function App() {
  return (
    <>
      <Banner
        images={['banner_1.png', 'banner_2.png']}
        bannerMobile="banner-home-mobile.png"
      />
      <Verticais />
      <Servicos />
      <Video />
      <Numeros />
      <Marcas />
      <Clientes />
      <Depoimentos />
      <Rodape />
    </>
  )
}

export default App
